import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { editIntervalFailed, editIntervalSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* editInterval(action) {
  try {
    const {
      data,
      id,
      iId,
    } = action.payload;
    delete data.created_at;
    delete data.updated_at;
    delete data.subscription_id;
    delete data.id;
    const url = `${BACKEND_URL}/proxy/subscription/v1/subscriptions/${id}/intervals/${iId}`;
    const dataResponse = yield makeRequest(url, data, action, 'PATCH', true);
    if (dataResponse.status === OK) {
      yield put(editIntervalSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(editIntervalFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editIntervalFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
